import React, { useMemo, useState } from 'react';
import { Tab, Tabs, Form, Pagination, Badge } from 'react-bootstrap';

const TIPOS_EQUIPO = ['Patrón', 'Prestamo', 'Auxiliar', 'Activo fijo', 'No definido'];
const PAGE_SIZE = 15;

const matchesSearch = (patron, search) => {
  if (!search) return true;
  const s = search.toLowerCase();
  const campos = [
    patron.item,
    patron.marca,
    patron.modelo,
    patron.serie,
    patron.inventario,
    patron.ubicacion,
    patron.estado,
    patron.movimiento,
    patron.tipoEquipo
  ];
  return campos.some(c => (c ?? '').toString().toLowerCase().includes(s));
};

const TablaPatronesPorTipo = ({ patrones, verActividades, add }) => {
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  const filtrados = useMemo(
    () => (patrones || []).filter(p => matchesSearch(p, search)),
    [patrones, search]
  );

  const totalPages = Math.max(1, Math.ceil(filtrados.length / PAGE_SIZE));
  const currentPage = Math.min(page, totalPages);
  const inicio = (currentPage - 1) * PAGE_SIZE;
  const pageItems = filtrados.slice(inicio, inicio + PAGE_SIZE);

  const pagItems = [];
  const maxBtns = 5;
  let start = Math.max(1, currentPage - Math.floor(maxBtns / 2));
  let end = Math.min(totalPages, start + maxBtns - 1);
  start = Math.max(1, end - maxBtns + 1);
  for (let n = start; n <= end; n++) {
    pagItems.push(
      <Pagination.Item key={n} active={n === currentPage} onClick={() => setPage(n)}>
        {n}
      </Pagination.Item>
    );
  }

  return (
    <div>
      <div className="d-flex justify-content-between align-items-center my-3 flex-wrap gap-2">
        <Form.Control
          type="text"
          placeholder="Buscar por equipo, marca, modelo, serie, inventario, ubicación, estado..."
          value={search}
          onChange={(e) => { setSearch(e.target.value); setPage(1); }}
          style={{ maxWidth: 480 }}
        />
        <small className="text-muted">
          Mostrando {pageItems.length} de {filtrados.length} equipos
          {search && (patrones?.length ?? 0) !== filtrados.length
            ? ` (${patrones?.length ?? 0} sin filtro)`
            : ''}
        </small>
      </div>

      <table className='table w-100 table-bordered'>
        <thead className="cabeceraitem">
          <tr>
            <th scope="col">Index</th>
            <th scope="col">Equipo</th>
            <th scope="col">Marca</th>
            <th scope="col">Modelo</th>
            <th scope="col">Serie</th>
            <th scope="col">Inventario</th>
            <th scope="col">Ubicación</th>
            <th scope="col">Estado</th>
            <th scope="col">Movilidad</th>
            <th scope="col">Actividades</th>
            <th><i className="bi bi-pencil-square"></i></th>
          </tr>
        </thead>
        <tbody>
          {pageItems.map((patron, index) => (
            <tr key={patron._id ?? index}>
              <td>{inicio + index + 1}</td>
              <td
                className="under_line cursor-p"
                onClick={() => {
                  window.open(`/PerfilPatron/${patron._id}`, '_blank');
                }}
              >{patron.item}</td>
              <td>{patron.marca}</td>
              <td>{patron.modelo}</td>
              <td>{patron.serie}</td>
              <td>{patron.inventario ? patron.inventario : "No tiene"}</td>
              <td>{patron.ubicacion}</td>
              <td>{patron.estado}</td>
              <td>{patron.movimiento}</td>
              <td><a className='cursor-p' onClick={() => verActividades(patron)}>Ver</a></td>
              <td><i className="bi bi-pencil-square cursor-p" onClick={() => add(patron)}></i></td>
            </tr>
          ))}
          {pageItems.length === 0 && (
            <tr>
              <td colSpan={11} className="text-center text-muted py-3">
                {search
                  ? 'No hay equipos que coincidan con la búsqueda.'
                  : 'No hay equipos en este tipo.'}
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {totalPages > 1 && (
        <div className="d-flex justify-content-center">
          <Pagination>
            <Pagination.First disabled={currentPage === 1} onClick={() => setPage(1)} />
            <Pagination.Prev disabled={currentPage === 1} onClick={() => setPage(currentPage - 1)} />
            {pagItems}
            <Pagination.Next disabled={currentPage === totalPages} onClick={() => setPage(currentPage + 1)} />
            <Pagination.Last disabled={currentPage === totalPages} onClick={() => setPage(totalPages)} />
          </Pagination>
        </div>
      )}
    </div>
  );
};

const PatronesList = ({ patrones, setPageForm, setPatronData, setEstadoModal, setTitulo, add }) => {
  const [activeKey, setActiveKey] = useState('Patrón');

  const verActividades = (data) => {
    setPatronData(data);
    setPageForm(5);
    setTitulo('Actividades');
    setEstadoModal(true);
  };

  const porTipo = useMemo(() => {
    const map = {};
    TIPOS_EQUIPO.forEach(t => { map[t] = []; });
    (patrones || []).forEach(p => {
      const tipo = p.tipoEquipo || 'No definido';
      if (!map[tipo]) map[tipo] = [];
      map[tipo].push(p);
    });
    return map;
  }, [patrones]);

  return (
    <div>
      <Tabs
        activeKey={activeKey}
        onSelect={(k) => k && setActiveKey(k)}
        id="inventario-tabs"
        className="mt-3"
      >
        {TIPOS_EQUIPO.map(tipo => {
          const lista = porTipo[tipo] || [];
          return (
            <Tab
              key={tipo}
              eventKey={tipo}
              title={
                <span>
                  {tipo} <Badge bg="secondary">{lista.length}</Badge>
                </span>
              }
            >
              <TablaPatronesPorTipo
                patrones={lista}
                verActividades={verActividades}
                add={add}
              />
            </Tab>
          );
        })}
      </Tabs>
    </div>
  );
};

export default PatronesList;
